<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ report.title }}</h4><a class="close" v-on:click="hideModal" :title="_('Close')">&times;</a>
    </div>
    <div class="modal-body">
      <p class="pull-right" v-if="report.duration && report.duration !== 'unknown'">{{ _('Duration') }}: {{ formatDuration(report.duration) }}</p>
      <h4>{{ getReportName(report.type) }}</h4>
      <p>{{ DateTime.fromSeconds(Number(report.ts), { zone: this.timezone }).toFormat(this.dateFormat) }} {{ _('at') }} {{ DateTime.fromSeconds(Number(report.ts), { zone: this.timezone }).toFormat(this.timeFormat) }}</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-info" v-on:click="copyReport(report.id)"><i class="fa fa-fw fa-copy"></i> {{ _('Copy') }}</button>
      <button class="btn btn-success" v-on:click="openReportXLSX(report.id)" v-if="isReportFormatSupported('xlsx', report.typeValue)"><i class="fa fa-fw fa-download"></i> {{ _('Download Excel') }}</button>
      <button class="btn btn-success" v-on:click="openReportPDF(report.id)" v-if="isReportFormatSupported('pdf', report.typeValue)"><i class="fa fa-fw fa-download"></i> {{ _('Download PDF') }}</button>
      <button class="btn btn-success" v-on:click="openReport(report.id)" v-if="isReportFormatSupported('html', report.typeValue)"><i class="fa fa-fw fa-eye"></i> {{ _('View HTML') }}</button>
      <button class="btn btn-primary" v-on:click="resendReport(report.id)" v-if="report.typeValue === 'accommodationstatistics' && report.isFeatureEnabled('statisticsfinland')"><i class="fa fa-fw fa-refresh"></i> {{ _('Send to Statistics Finland') }}</button>
      <button class="btn btn-default" v-on:click="viewStatisticsReport(report.id)" v-if="report.typeValue === 'accommodationstatistics' && report.isFeatureEnabled('statisticsfinland')"><i class="fa fa-fw fa-eye"></i> {{ _('Display Statistics Finland report') }} (XML)</button>
    </div>
  </div>
</template>

<script>
import { DateTime, Duration } from 'luxon'
import { mapGetters } from 'vuex'
import reporttypes from '~/lib/reporttypes'
import settingshelpers from '~/lib/settingshelpers'

export default {
  props: ['report'],
  mixins: [reporttypes, settingshelpers],
  data () {
    return {
      DateTime: DateTime
    }
  },
  computed: {
    ...mapGetters(['dateFormat', 'timeFormat', 'timezone'])
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    copyReport (id) {
      this.$emit('copyReport', id)
    },
    openReportXLSX (id) {
      this.$emit('openReportXLSX', id)
    },
    openReportPDF (id) {
      this.$emit('openReportPDF', id)
    },
    openReport (id) {
      this.$emit('openReport', id)
    },
    resendReport(id) {
      this.$emit('resendReport', id)
    },
    viewStatisticsReport(id) {
      this.$emit('viewStatisticsReport', id)
    },
    formatDuration(ms) {
      const duration = Duration.fromMillis(Number(ms))
      const min = Math.floor(duration.as('minutes'))
      const sec = Math.floor(duration.as('seconds'))
      if (min >= 1) {
        return `${min}m ${sec % 60}s`
      } else if (sec >= 1) {
        return `${sec}s ${ms % 1000}ms`
      } else {
        return `${ms}ms`
      }
    }
  }
}
</script>